import React, { useState, useRef } from "react";
import {
  Button,
  Row,
  Col,
  Space,
  Form,
  Input,
  DatePicker,
  Select,
  Table,
  notification,
  Spin,
  message} from "antd";
import {
  SearchOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";

import moment from "moment";
import itemTakeApi from "constants/api/itemTake";
import util from "helpers/util";
import CModal from "./CModal";
import { saveAs } from "file-saver";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

export default function TakeList() {
  const dateFormat = "YYYY-MM-DD";

  const [formTakeList] = Form.useForm();

  const [isLoadingTbTakeList, setisLoadingTbTakeList] = useState(false);
  const [rowsUploadStatusList, setRowsUploadStatusList] = useState([]);
  const [tbUSListSearchText, setTbStockTakeListSearchText] = useState("");
  const [tbUSListSearchedColumn, setTbStockTakeListSearchedColumn] = useState("");

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataModal, setDataModal] = useState({});

  const [isLoading, setIsLoading] = useState(false);

  const tbStockTakeListSearchInput = useRef(null);
  const history = useHistory();

  const tbStockTakeListHandleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setTbStockTakeListSearchText(selectedKeys[0]);
    setTbStockTakeListSearchedColumn(dataIndex);
  };

  const tbStockTakeListHandleReset = (clearFilters) => {
    clearFilters();
    setTbStockTakeListSearchText("");
  };

  const onCloseCModal = () => {
    setIsModalVisible(false);
    setDataModal({});
  };

  const showCModal = (token) => {
    setIsLoading(true);

    itemTakeApi
      .getItemTakeDetail(token)
      .then((res) => {
        setDataModal(res.result);
        setIsModalVisible(true);
        setIsLoading(false);
      })
      .catch((err) => {
        notification.error({
          message: err,
          duration: 0,
        });
        setIsLoading(false);
      });
  };

  const onActionDropDownChange = (selectedDropDown) => {
    const data = selectedDropDown.value.split("|");

    if (selectedDropDown.label === "Detail") {
      showCModal(data[1]);
    } else {
      history.push("/ItemTake/UploadStockTakeResult", { token: data[1] });
    }
  };

  const onFinishFormTakeLists = (values) => {
    setisLoadingTbTakeList(true);

    var dataToSubmit = {
      actionDate: values.actionDate == null
        ? null
        : values.actionDate.format(dateFormat),
      //status: values.status
    };

    itemTakeApi
      .getListItemTakes(dataToSubmit)
      .then((res) => {
        if (res.success) {
          let newRows = [];
          if (res.success) {
            res.result.sort(function(a,b){
              return moment(b.creationTime).unix() - moment(a.creationTime).unix();
            });
            res.result.map((row, index) => {
              newRows.push({
                key: row.id,
                index: index + 1,
                store: row.store,
                token: row.token,
                actionDate: util.formatNullableDatetime(row.actionDate),
                status: row.status
              });
            });
            setRowsUploadStatusList(newRows);
          }

          setisLoadingTbTakeList(false);
        }
      })
      .catch((err) => {
          notification.error({
            message: "Internal server error. please contact administrator",
            duration: 0,
          });
        setisLoadingTbTakeList(false);
      });
  };

  const onFinishFailedFormTakeLists = (errorInfo) => {
    notification.error({
      message: "Failed to get data",
      duration: 0,
    });
  };

  const tbTakeListGetColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={tbStockTakeListSearchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            tbStockTakeListHandleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              tbStockTakeListHandleSearch(selectedKeys, confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => tbStockTakeListHandleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setTbStockTakeListSearchText(selectedKeys[0]);
              setTbStockTakeListSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    render: (text) =>
      tbUSListSearchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[tbUSListSearchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columnsTakeList = [
    {
      title: "#",
      dataIndex: "index",
      width: 40,
      align: "center",
      sorter: (a, b) => a.index - b.index,
    },
    {
      title: "Token",
      dataIndex: "token",
      ...tbTakeListGetColumnSearchProps("token"),
      sorter: (a, b) => a.token.localeCompare(b.token),
    },
    {
      title: "Store",
      dataIndex: "store",
      ...tbTakeListGetColumnSearchProps("store"),
      sorter: (a, b) => a.store - b.store,
    },
    {
      title: "Action Date",
      dataIndex: "actionDate",
      ...tbTakeListGetColumnSearchProps("actionDate"),
      sorter: (a, b) =>
        moment(a.actionDate).unix() - moment(b.actionDate).unix(),
    },
    {
      title: "Action",
      render: (_, record) => (
        <Select
          labelInValue
          style={{ width: "100%" }}
          defaultValue={{ label: "Action", value:"default-selected" }}
          onChange={(selectedDropDown) => onActionDropDownChange(selectedDropDown)}
          value={{ label: "Action", value:"default-selected" }}
          options={[
            {
              value: 'D|' + record.token,
              label: 'Detail',
            },
            {
              value: 'R|' + record.token,
              label: 'Result',
            },
            {
              value: '',
              label: 'Action',
              disabled: true,
              hidden: true
            },
          ]}
        >
        </Select>
      ),
    }
  ];

  return (
    <>
      <CModal
        visible={isModalVisible}
        onClose={onCloseCModal}
        onCancel={() => setIsModalVisible(false)}
        dataModal={dataModal}
      />
      <Spin tip="Loading..." size="large" spinning={isLoading}>
        <Row>
          <Col span={24}>
              <Form
                layout="vertical"
                form={formTakeList}
                onFinish={onFinishFormTakeLists}
                initialValues={{
                  creationDate: null,
                  status: "ALL",
                }}
                onFinishFailed={onFinishFailedFormTakeLists}
              >
                <Row gutter={10} align="bottom">
                  <Col span={4}>
                    <Form.Item label="Action Date" name="actionDate">
                      <DatePicker
                        format={dateFormat}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Form.Item>
                      <Button block type="primary" htmlType="submit">
                        Fetch
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify="end" gutter={15}></Row>
              </Form>
          </Col>
        </Row>
        <Row>
          <Col>
          </Col>
        </Row>
        <br />
        <Row>
          <Col span={24}>
            <Table
              size="small"
              loading={isLoadingTbTakeList}
              columns={columnsTakeList}
              dataSource={rowsUploadStatusList}
              pagination={{ pageSize: 5 }}
              bordered
            />
          </Col>
        </Row>
      </Spin>
    </>
  );
}
